import { oneOfType, arrayOf, string, number, shape, func } from 'prop-types';
var threshold = oneOfType([number, func]);
var gradation = arrayOf(oneOfType([shape({
  unit: string.isRequired,
  factor: number,
  granularity: number,
  threshold: threshold // Specific `threshold_[unit]` properties may also be defined

}), shape({
  format: func.isRequired,
  threshold: threshold // Specific `threshold_[unit]` properties may also be defined

})])); // Date/time formatting style.
// E.g. 'twitter', 'fuzzy', or custom (`{ gradation: […], units: […], flavour: 'long', custom: function }`)

export var style = oneOfType([string, shape({
  gradation: gradation,
  units: arrayOf(string),
  flavour: oneOfType([string, arrayOf(string)]),
  custom: func
})]);
//# sourceMappingURL=PropTypes.js.map